import { DATE_PERIOD } from '../../../../common/form/formConstants';
import { PRICING_CONSTANTS } from '../../../../pricing/PricingConstants';

// CONSTANTS
export const RESOURCE_ORDERS_TYPE_ID = {
    order: 'order',
    quote: 'quote',
    deal: 'deal'
} as const;

export const RESOURCE_ORDERS_ACTION_TYPE_ID = {
    save: 'save',
    confirm: 'confirm'
} as const;

export const RESOURCE_ORDER_AI_EXTRACTED_DATA_TYPE = {
    draftOrderFromDocument: 'draftOrderFromDocument',
    draftQuoteFromDocument: 'draftQuoteFromDocument'
} as const;

export const RESOURCE_ORDERS_SERVICE_FIELDS = {
    orders: 'orders',
    proposals: 'proposals'
};

export const ORDER_INPUT_OPTIONS = {
    manual: 'Manual',
    upload: 'Upload'
};

export const MUTATION_NAMES = {
    saveQuote: 'SaveProductionQuote',
    saveOrder: 'SaveProductionOrder',
    saveDeal: 'SaveProductionDeal',
    saveOrderTemplate: 'SaveOrderTemplate',
    confirmOrder: 'ConfirmProductionOrder',
    confirmQuote: 'SendProductionQuote',
    confirmDeal: 'ConfirmProductionDeal',
    deleteOrderTemplate: 'DeleteOrderTemplate'
};

export const ROOT_FIELDS = {
    saveOrder: 'saveProductionOrder',
    saveQuote: 'saveProductionQuote',
    saveDeal: 'saveProductionDeal',
    saveOrderTemplate: 'saveOrderTemplate',
    confirmOrder: 'confirmProductionOrder',
    confirmQuote: 'sendProductionQuote',
    confirmDeal: 'confirmProductionDeal',
    deleteOrder: 'deleteOrder'
};

export const RESOURCE_ORDER_INPUT_TYPE_NAMES = {
    orderInputType: 'orderInputType',
    attachments: 'attachments'
};

export const RESOURCE_ORDERS_EDITOR_NAMES = {
    organization: 'salesOrganization',
    orderOrganization: 'orderOrganization',
    orgContact: 'orgContact',
    orgAddress: 'orgAddress',
    bookingPeriod: 'bookingPeriod',
    durationSpecified: `bookingPeriod.${DATE_PERIOD.dateRange}.${DATE_PERIOD.durationSpecified}`,
    dateRange: `bookingPeriod.${DATE_PERIOD.dateRange}`,
    name: 'name'
};

export const RESOURCE_ORDER_COST_SUMMARY_NAMES = {
    currency: 'currency',
    base: PRICING_CONSTANTS.costSummaryBase,
    discount: PRICING_CONSTANTS.costSummaryDiscount,
    discountedTotal: PRICING_CONSTANTS.costSummaryDiscountedTotal,
    total: PRICING_CONSTANTS.costSummaryTotal
};

export const RESOURCE_ORDERS_EDITOR_DOCUMENTATION_NAMES = {
    terms: 'terms',
    note: 'note',
    attachments: 'attachments'
};

export const RESOURCE_ORDERS_EDITOR_APPROVALS_NAMES = {
    role: 'role',
    isSequential: 'isSequential',
    workflowSteps: 'workflowSteps',
    workflowParticipant: 'workflowParticipant',
    contacts: 'contacts',
    messageContent: 'messageContent',
    approverRole: 'approverRole',
    approverIsSequence: 'approverIsSequence',
    approverContact: 'approverContact',
    approverMessage: 'approverMessage',
    notifyContact: 'notifyContact'
} as const;

export const RESOURCE_ORDER_EDITOR_FIELDS = {
    ...RESOURCE_ORDERS_EDITOR_NAMES,
    ...RESOURCE_ORDER_COST_SUMMARY_NAMES,
    ...RESOURCE_ORDERS_EDITOR_DOCUMENTATION_NAMES,
    ...RESOURCE_ORDERS_EDITOR_APPROVALS_NAMES,
    status: 'status',
    state: 'state',
    costSummary: 'costSummary',
    identity: 'identity',
    orderVersion: 'orderVersion',
    orderNumber: 'orderNumber',
    production: 'production'
} as const; // as const is a typescript issue resolved. It allows us to use these defined keys as object keys even though they are technically a string

export const SAVE_ORDER_RESPONSE_KEY = {
    order: 'saveProductionOrder',
    quote: 'saveProductionQuote',
    deal: 'saveProductionDeal'
};

export const CONFIRM_ORDER_RESPONSE_KEY = {
    order: 'confirmProductionOrder',
    quote: 'sendProductionQuote',
    deal: 'confirmProductionDeal'
};
